import { Injectable } from '@angular/core';
import { AuthService } from 'elbuild-ui-lib-core';
import { environment } from 'src/environments/environment';
import { ShopCartService, WishlistService, RouteGuardService } from 'yf-commerce-ui-lib';
import { IframeService } from './iframe.service';

@Injectable({
	providedIn: 'root'
})
export class AccountService {

	constructor(private authService: AuthService,
		private cartService: ShopCartService,
		private wishlistService: WishlistService,
		private guardService: RouteGuardService,
		private iframeService: IframeService
	) { }


	logout(redirect: boolean, propagate: boolean): void {
		this.authService.asynclogout().subscribe(() => {
			this.cartService.clearData();
			this.wishlistService.clearData();
			this.guardService.reset();
			this.cartService.initShop(environment.storecode);
			this.wishlistService.initShop(environment.storecode);
			if (redirect) {
				window.location.href = environment.baseURL;
			}
			if (propagate) {
				this.iframeService.postMessage({ event: 'logout' }, environment.baseURL);
			}
		});


	}
}
